var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParachute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0451 31.5C24.5296 28.0155 28.0155 26.2733 31.5 26.2733C34.9845 26.2733 38.4704 28.0155 41.9549 31.5C46.0202 28.0155 49.0706 26.2733 51.1018 26.2733C53.1344 26.2733 56.1847 28.0155 60.25 31.5C60.25 15.6214 47.3786 2.75 31.5 2.75C15.6214 2.75 2.75 15.6214 2.75 31.5C6.81525 28.0155 9.86563 26.2733 11.8983 26.2733C13.9309 26.2733 16.9798 28.0155 21.0451 31.5Z",
    fill: "#F87CE4",
    stroke: "#F87CE4",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 31.5L31.5 60.25M31.5 60.25L21.0451 31.5M31.5 60.25L41.9549 31.5M31.5 60.25L60.25 31.5",
    stroke: "#F87CE4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParachute);
export default __webpack_public_path__ + "static/media/parachute.9ecf884787cf0ca4deb470238ae030b8.svg";
export { ForwardRef as ReactComponent };